import Vue, {VueConstructor} from "vue";
import ParseURL from "@/utils/ParseURL";
const parseURL = (url:string) =>{
  return ParseURL(url);
};
declare module "vue/types/vue" {
  interface Vue {
    $parseURL: typeof parseURL
  }
}

Vue.use((vue:VueConstructor)=>{
  vue.prototype.$parseURL=parseURL;
});

